// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/my_profile_cover.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ProfileCoverType } from "../../../accounts/profile_cover_type_pb";
import { file_accounts_profile_cover_type } from "../../../accounts/profile_cover_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/my_profile_cover.proto.
 */
export const file_entities_app_my_account_my_profile_cover: GenFile = /*@__PURE__*/
  fileDesc("Ci5lbnRpdGllcy9hcHAvbXlfYWNjb3VudC9teV9wcm9maWxlX2NvdmVyLnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQiZQoOTXlQcm9maWxlQ292ZXISSgoLY292ZXJfaW1hZ2UYASABKAsyMy5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQuTXlQcm9maWxlQ292ZXJJbWFnZUgAQgcKBWNvdmVyIrwBChNNeVByb2ZpbGVDb3ZlckltYWdlEhEKCWltYWdlX3VybBgBIAEoCRIUCgxzb3VyY2Vfd2lkdGgYAiABKAUSFQoNc291cmNlX2hlaWdodBgDIAEoBRI1Cgpjb3Zlcl90eXBlGAQgASgOMiEucHJvdG9zLmFjY291bnRzLlByb2ZpbGVDb3ZlclR5cGUSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBiBnByb3RvMw", [file_google_protobuf_timestamp, file_accounts_profile_cover_type]);

/**
 * @generated from message protos.entities.app.my_account.MyProfileCover
 */
export type MyProfileCover = Message<"protos.entities.app.my_account.MyProfileCover"> & {
  /**
   * @generated from oneof protos.entities.app.my_account.MyProfileCover.cover
   */
  cover: {
    /**
     * @generated from field: protos.entities.app.my_account.MyProfileCoverImage cover_image = 1;
     */
    value: MyProfileCoverImage;
    case: "coverImage";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.entities.app.my_account.MyProfileCover.
 * Use `create(MyProfileCoverSchema)` to create a new message.
 */
export const MyProfileCoverSchema: GenMessage<MyProfileCover> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_my_profile_cover, 0);

/**
 * @generated from message protos.entities.app.my_account.MyProfileCoverImage
 */
export type MyProfileCoverImage = Message<"protos.entities.app.my_account.MyProfileCoverImage"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * @generated from field: int32 source_width = 2;
   */
  sourceWidth: number;

  /**
   * @generated from field: int32 source_height = 3;
   */
  sourceHeight: number;

  /**
   * @generated from field: protos.accounts.ProfileCoverType cover_type = 4;
   */
  coverType: ProfileCoverType;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.my_account.MyProfileCoverImage.
 * Use `create(MyProfileCoverImageSchema)` to create a new message.
 */
export const MyProfileCoverImageSchema: GenMessage<MyProfileCoverImage> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_my_profile_cover, 1);

